var _require = require('../errors'),
    ArgumentError = _require.ArgumentError;

var _require2 = require('../JwksClient'),
    JwksClient = _require2.JwksClient;

var supportedAlg = require('./config');

module.exports.koaJwtSecret = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!options.jwksUri) {
    throw new ArgumentError('No JWKS provided. Please provide a jwksUri');
  }

  var client = new JwksClient(options);
  return function secretProvider() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alg = _ref.alg,
        kid = _ref.kid;

    return new Promise(function (resolve, reject) {
      if (!supportedAlg.includes(alg)) {
        return reject(new Error('Missing / invalid token algorithm'));
      }

      client.getSigningKey(kid).then(function (key) {
        resolve(key.publicKey || key.rsaPublicKey);
      }).catch(function (err) {
        if (options.handleSigningKeyError) {
          return options.handleSigningKeyError(err).then(reject);
        }

        return reject(err);
      });
    });
  };
};